module.exports = __webpack_public_path__ + "img/3.abd74342.png";